// import config from './index';
const REACT_APP_API_BASE_URL = process.env?.REACT_APP_API_BASE_URL;

const getFullUrl = (url) => {
  return `${REACT_APP_API_BASE_URL}${url}`;
};

export const apiurl = {
  getexpenseitemlist: getFullUrl('manning-po/v1/ExpenseItem/getexpenseitemlist'),
  getexpenseMaster: getFullUrl('manning-po/v1/ExpenseItem/getexpenseitem'),
  addExpenseItem: getFullUrl('manning-po/v1/ExpenseItem/addExpenseItem'),
  editExpenseItem: getFullUrl('manning-po/v1/ExpenseItem/updateExpenseItem'),
  deleteExpenseItem: getFullUrl('manning-po/v1/ExpenseItem/deleteexpenseitem'),
  getVendorList: getFullUrl('manning-po/v1/VendorMaster/getVendorMasterlist'),
  addVendorMaster: getFullUrl('manning-po/v1/VendorMaster/addVendor'),
  updateVendorMaster: getFullUrl('manning-po/v1/VendorMaster/updateVendor'),
  getVendorDashBoardVendorList: getFullUrl('manning-po/v1/VendorPo/getVendorListbyCompany'),
  getCompanyList: getFullUrl('manning-po/v1/VendorMaster/getCompanylist'),
  editVendor: getFullUrl('manning-po/v1/VendorMaster/addVendorExpense'),
  getCurrency: getFullUrl('manning-po/v1/VendorMaster/getCurrencylist'),
  deleteVendor: getFullUrl('manning-po/v1/VendorMaster/deleteVendorExpenses'),
  deleteEachVendorExpense: getFullUrl('manning-po/v1/VendorMaster/deleteEachVendorExpenses'),
  getPOList: getFullUrl('manning-po/v1/PurchaseOrder/getPurchaseOrderList'),
  getVendorPOList: getFullUrl('manning-po/v1/VendorPo/getVendorPurchaseOrderList'),
  getExpenseCategoryJSONlist: getFullUrl('manning-po/v1/VendorMaster/getExpenseCategorylist'),
  getCrewList: getFullUrl('manning-po/v1/PurchaseOrder/getCrewList'),
  getDefaultCrew: getFullUrl('manning-po/v1/PurchaseOrder/defaultCrew'),
  getItemType: getFullUrl('manning-po/v1/ExpenseItem/GetExpenseItemType'),
  addPO: getFullUrl('manning-po/v1/PurchaseOrder/addPurchaseOrder'),
  deletePo: getFullUrl('manning-po/v1/PurchaseOrder/deletePurchaseOrder'),
  getPO: getFullUrl('manning-po/v1/PurchaseOrder/getPurchaseOrder'),
  editPO: getFullUrl('manning-po/v1/PurchaseOrder/updatePurchaseOrder'),
  getVendorPO: getFullUrl('manning-po/v1/VendorPo/getPurchaseOrder'),
  downloadPO: getFullUrl('manning-po/v1/Comment/DownloadPO'),
  sendPO: getFullUrl('manning-po/v1/Comment/SendPO'),
  getComments: getFullUrl('manning-po/v1/Comment/getPOComments'),
  getVendorComments: getFullUrl('manning-po/v1/VendorPo/getPOComments'),
  addComment: getFullUrl('manning-po/v1/Comment/SavePOComments'),
  getCrew: getFullUrl('manning-po/v1/PurchaseOrder/Crew/Details'),
  getPortList: getFullUrl('manning-po/v1/PurchaseOrder/getPortList'),
  getPaymentTerms: getFullUrl('manning-po/v1/PurchaseOrder/getPaymentTerms'),
  getAdvanceRequestPurchaseOrder: getFullUrl('manning-po/v1/PurchaseOrder/getAdvanceRequestPurchaseOrder'),
  getVesselList: getFullUrl('manning-po/v1/PurchaseOrder/getVesselList'),
  getLevelOnePurpose: getFullUrl('manning-po/v1/PurchaseOrder/getPurpose'),
  getLevelTwoPurpose: getFullUrl('manning-po/v1/PurchaseOrder/getPurposeLevel'),
  getFullVesselList: getFullUrl('manning-po/v1/PurchaseOrder/getAllVesselList'),
  getCompanyListByVessel: getFullUrl('manning-po/v1/PurchaseOrder/getCompanyListByVesselName'),
  exportPOs: getFullUrl('manning-po/v1/PurchaseOrder/Export'),
  exportCommitedPOs: getFullUrl('manning-po/v1/PurchaseOrder/Export/CommittedCostReport'),
  getDuplicatePO: getFullUrl('manning-po/v1/PurchaseOrder/GetDuplicatePOExists'),
  getVesselOwnerList: getFullUrl('manning-po/v1/PurchaseOrder/getVesselOwnerList'),
  saveSendPurchaseOrder: getFullUrl('manning-po/v1/PurchaseOrder/purchaseOrderSend'),
  getPolicies: getFullUrl('manning-po/v1/Policy/policies'),
  getVendorCategory: getFullUrl('manning-po/v1/VendorMaster/vendorList'),
  getVendorExpenseitem: getFullUrl('manning-po/v1/VendorMaster/expenseitemlist'),
  deleteLineItemLevel: getFullUrl('manning-po/v1/PurchaseOrder/DeleteLineItemLevel'),
  getPartialSearch: getFullUrl('manning-po/v1/PurchaseOrder/CrewList'),
  getIntegrationLogList: getFullUrl('manning-po/v1/Log/getIntegrationLogList'),
  getAllPpeComponentMaster: getFullUrl('manning-po/v1/PpeKit/getAllPpeComponentMaster'),
  deletePpeComponentMaster: getFullUrl('manning-po/v1/PpeKit/deletePpeComponentMaster'),
  createPpeComponentMaster: getFullUrl('manning-po/v1/PpeKit/createPpeComponentMaster'),
  updatePpeComponentMaster: getFullUrl('manning-po/v1/PpeKit/updatePpeComponentMaster'),
  getAllPpeMaster: getFullUrl('manning-po/v1/PpeKit/getAllPpeMaster'),
  getPpeComponentList: getFullUrl('manning-po/v1/PpeKit/getPpeComponentList'),
  createPpeComponent: getFullUrl('manning-po/v1/PpeKit/createPpeComponent'),
  updatePpeComponent: getFullUrl('manning-po/v1/PpeKit/updatePpeComponent'),
  deletePpeComponent: getFullUrl('manning-po/v1/PpeKit/deletePpeComponent'),
  getPpeKit: getFullUrl('manning-po/v1/PpeKit/getPpeKit'),
  getReasonList: getFullUrl('manning-po/v1/Reason'),
  getCourceList: getFullUrl('manning-po/v1/ExpenseItem/courseList'),
  validateCourseCode: getFullUrl('manning-po/v1/PurchaseOrder/validateCourseCode'),
  getPpeVesselGroup: getFullUrl('manning-po/v1/PpeKit/getPpeVesselGroup'),
  getPpeVesselList: getFullUrl('manning-po/v1/PpeKit/getPpeVesselList'),
  createPpeVesselGroup: getFullUrl('manning-po/v1/PpeKit/createPpeVesselGroup'),
  updatePpeVesselGroup: getFullUrl('manning-po/v1/PpeKit/updatePpeVesselGroup'),
  getAllPpeComponent: getFullUrl('manning-po/v1/PpeKit/getAllPpeComponent'),
  getShortCloseApproval: getFullUrl('manning-po/v1/PurchaseOrder/short_close_approval'),
  initiateShortClose: getFullUrl('manning-po/v1/PurchaseOrder/initiate_short_close'),
  initiateShortCloseLineItem: getFullUrl('manning-po/v1/PurchaseOrder/initiate_short_close_line_item'),
  confirmShortCloseItem: getFullUrl('manning-po/v1/PurchaseOrder/Short_close_approve_reject'),
  confirmVendorShortCloseItem: getFullUrl('manning-po/v1/VendorPo/Short_close_approve_reject'),
  getShortCloseReasons: getFullUrl('manning-po/v1/vendormaster/short_close_reasons'),
  getVesselRoles: getFullUrl('manning-po/v1/vendormaster/vessel_roles'),
  updateVendorEmail: getFullUrl('manning-po/v1/PurchaseOrder/vendor_email_updated'),
  getVesselPoDefaultCrew: getFullUrl('manning-po/v1/PurchaseOrder/defaultVesselPoCrew'),
  checkPOBudgetType: getFullUrl('manning-po/v1/PurchaseOrder/CheckPOBudgetType'),
  getAgencyPOConfig: getFullUrl('manning-po/v1/PurchaseOrder/getAgencyPOConfig'),
  uploadPoAttachment: getFullUrl('manning-po/v1/PurchaseOrder/upload'),
  getPoAttachments: getFullUrl('manning-po/v1/PurchaseOrder/getPoAttachments'),
  deletePoAttachment: getFullUrl('manning-po/v1/PurchaseOrder/deletePoAttachment'),
  getPoApprovalFlowLog: getFullUrl('manning-po/v1/PurchaseOrder/getPoApprovalFlowLog'),
  getLevel2ApproverList: getFullUrl('manning-po/v1/PurchaseOrder/getLevel2ApproverList'),
  getPoRequestApproval: getFullUrl('manning-po/v1/PurchaseOrder/poRequestApproval'),
  updateLevel2Approver: getFullUrl('manning-po/v1/PurchaseOrder/UpdateLevel2Approver'),
  getAdvancePoCancellation: getFullUrl('manning-po/v1/PurchaseOrder/advancePoCancellation'),
  getVesselCostCentreList: getFullUrl('manning-po/v1/VesselCostCenter/getvesselcostcenterlist'),
  downloadVesselCostCentreTemplate: getFullUrl('manning-po/v1/VesselCostCenter/downloadVesselCostCenterTemplate'),
  uploadVesselCostCentre: getFullUrl('manning-po/v1/VesselCostCenter/uploadVesselCostCenter'),
  deleteVesselCostCentre: getFullUrl('manning-po/v1/VesselCostCenter/deleteVesselCostCenter'),
  getFixedBudgetVesselList: getFullUrl('manning-po/v1/VesselCostCenter/getFixedBudgetVesselList'),
  downloadFixedBudgetVesselTemplate: getFullUrl('manning-po/v1/VesselCostCenter/downloadFixedBudgetVesselTemplate'),
  uploadFixedBudgetVessel: getFullUrl('manning-po/v1/VesselCostCenter/uploadFixedBudgetVessel'),
  deleteFixedBudgetVessel: getFullUrl('manning-po/v1/VesselCostCenter/deleteFixedBudgetVessel'),
  getFixedBudgetVesselAccCodeList: getFullUrl('manning-po/v1/VesselCostCenter/getFixedBudgetVesselAccCodeList'),
  downloadFixedBudgetVesselAccCodeTemplate: getFullUrl('manning-po/v1/VesselCostCenter/downloadFixedBudgetVesselAccCodeTemplate'),
  uploadFixedBudgetVesselAccCode: getFullUrl('manning-po/v1/VesselCostCenter/uploadFixedBudgetVesselAccCode'),
  deleteFixedBudgetVesselAccCode: getFullUrl('manning-po/v1/VesselCostCenter/deleteFixedBudgetVesselAccCode')

};
